// extracted by mini-css-extract-plugin
export default {"projectMenuWrapper":"uGUREtkTnlY9xmFZ2UQJ","projectMenu":"cOihxsaYg_7Grp3acBTa"};